import { FC } from 'react';
import styled from 'styled-components';

import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

import { useI18nValues } from '../hooks/useI18nValues';

import { PidTypeIcon } from './PidTypeIcon';

type PidTypeProps = {
  type: PersonalIdentifierType;
  icon?: boolean;
  name?: boolean;
};

export const PidType: FC<PidTypeProps> = ({ type, icon, name }) => {
  const values = useI18nValues();

  const showIcon = (!icon && !name) || icon;
  const showName = (!icon && !name) || name;

  return (
    <Container>
      {showIcon && <PidTypeIcon type={type} />}
      {showName && <span>{values.type(type)}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
